<footer class="footerutama">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-sm-6">
        <h6 class="mb-2 mt-2 text-success">Layanan</h6>

        <ul class="list-unstyled">
          <li class="mb-2" v-for="variable in variables" :key="variable.id">
            <router-link :to="'/variable/'+variable.code" class="text-black"
              >{{ variable.title }}</router-link
            >
          </li>
          <router-link to="/faq" class="text-black">FAQ</router-link>
        </ul>
      </div>

      <div class="col-lg-4 col-sm-6">
        <h6 class="mb-2 mt-2 text-success">Kebijakan</h6>

        <ul class="list-unstyled">
          <li
            class="mb-2"
            v-for="variable in policy_variables"
            :key="variable.id"
          >
            <router-link :to="'/variable/'+variable.code" class="text-black"
              >{{ variable.title }}</router-link
            >
          </li>
        </ul>
      </div>

      <div class="col-lg-4 col-sm-6">
        <h6 class="mb-2 mt-2 text-success">Produk</h6>

        <ul class="list-unstyled">
          <li class="mb-2" v-for="category in categories" :key="category.id">
            <router-link
              :to="'/product?category_id='+category.id"
              class="text-black"
              >{{category.name}}</router-link
            >
          </li>
        </ul>
      </div>

      <div class="moreinfo col-12 col-md-6 col-sm-12 mt-3">
        <h6 class="mb-3 text-success">Metode Pembayaran</h6>
        <div class="row">
          <div class="col-4 col-lg-2 col-sm-4">
            <img src="@/assets/img/bank/a1.png" alt="" />
          </div>
          <div class="col-4 col-lg-2 col-sm-4">
            <img src="@/assets/img/bank/b1.png" alt="" />
          </div>
          <div class="col-4 col-lg-2 col-sm-4">
            <img src="@/assets/img/bank/c2.png" alt="" />
          </div>
          <div class="col-4 col-lg-2 col-sm-4">
            <img src="@/assets/img/bank/c4.png" alt="" />
          </div>
          <div class="col-4 col-lg-2 col-sm-4">
            <img src="@/assets/img/bank/c5.png" alt="" />
          </div>
          <div class="col-4 col-lg-2 col-sm-4">
            <img src="@/assets/img/bank/c9.webp" alt="" />
          </div>
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/a2.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/a3.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/b2.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/b3.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/b4.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/c1.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/c3.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/c6.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/c7.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/c8.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/d1.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/d2.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/e1.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/e2.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/e3.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/e4.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/e5.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/f1.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/bank/f2.png" alt="" />
              </div> -->
        </div>
      </div>
      <div class="moreinfo col-12 col-md-6 col-sm-12 mt-3">
        <h6 class="mb-3 text-success">Jasa Pengiriman</h6>
        <div class="row">
          <div class="col-4 col-lg-2 col-sm-4">
            <img src="@/assets/img/anteraja.png" alt="" />
          </div>
          <div class="col-4 col-lg-2 col-sm-4">
            <img src="@/assets/img/jnt.png" alt="" />
          </div>
          <div class="col-4 col-lg-2 col-sm-4">
            <img src="@/assets/img/logo-jne.png" alt="" />
          </div>
          <div class="col-4 col-lg-2 col-sm-4">
            <img src="@/assets/img/sicepat.png" alt="" />
          </div>
          <div class="col-4 col-lg-2 col-sm-4">
            <img src="@/assets/img/wahana.png" alt="" />
          </div>
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/grab.png" alt="" />
              </div> -->
          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/gojek.png" alt="" />
              </div> -->

          <!-- <div class="col-4 col-lg-3 col-sm-4">
                <img src="@/assets/img/logo-pos-id.png" alt="" />
              </div> -->
        </div>
      </div>

      <div class="col-lg-4 col-sm-12 mt-3">
        <div
          class="d-flex justify-content-center align-items-center"
          style="height: 80px"
        >
          <router-link to="/" title="Togamas.com">
            <img
              class="img-fluid footer-logo text-center"
              src="/logo-togamas.png"
              alt=""
            />
          </router-link>
        </div>
      </div>
      <div class="col-lg-4 col-sm-12 mt-3">
        <div
          class="d-flex align-items-center justify-content-center"
          style="height: 80px"
        >
          <h6 class="text-center fw-bold">
            TOKO BUKU ONLINE TERPERCAYA DI INDONESIA
          </h6>
        </div>
      </div>

      <div class="my-element col-lg-4 col-sm-12 mt-3">
        <div
          class="d-flex justify-content-center align-items-center"
          style="height: 80px"
        >
          <div class="row">
            <div class="col">
              <a
                href="https://www.instagram.com/togamasdotcom/?hl=en"
                target="blank"
              >
                <img src="@/assets/img/sosmed/instagram.png" alt="" />
              </a>
            </div>
            <div class="col">
              <a
                href="https://web.facebook.com/togamas/?_rdc=1&_rdr"
                target="blank"
              >
                <img src="@/assets/img/sosmed/facebook.png" alt="" />
              </a>
            </div>
            <div class="col">
              <a href="https://twitter.com/togamas?lang=en" target="blank">
                <img src="@/assets/img/sosmed/twitter.png" alt="" />
              </a>
            </div>
            <div class="col">
              <a
                href="https://www.tiktok.com/@togamas_com?is_from_webapp=1&sender_device=pc"
                target="blank"
              >
                <img src="@/assets/img/sosmed/tiktok.png" alt="" />
              </a>
            </div>
            <div class="col">
              <a href="https://wa.me/628123312323" target="blank">
                <img src="@/assets/img/sosmed/whatsapp.png" alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <!--Grid column-->
    </div>
    <!--Grid row-->
    <p class="text-center">
      <small>
        <router-link to="/"
          >Copyright © 2016-2023 Togamas — All Rights Reserved</router-link
        >
      </small>
    </p>
  </div>
  <!-- Grid container -->
</footer>
